/**
 * As cores dos cabos, na ordem em que o comprador as usa há anos na planilha
 * dele. Manter a ordem importa: quem confere uma cotação de 59 linhas procura
 * o amarelo sempre na primeira coluna.
 */
export const ORDEM_CORES = [
  'Am', 'Az', 'Bc', 'Pt', 'Vd', 'Vm', 'Vd/Am', 'Cz', 'LJ', 'LL', 'Mr', 'Cristal', 'Nú', 'pt/vm',
];

export const COR_FUNDO: Record<string, string> = {
  Am: '#eab308', Az: '#2563eb', Bc: '#ffffff', Pt: '#1e293b', Vd: '#16a34a',
  Vm: '#dc2626', Cz: '#94a3b8', LJ: '#ea580c', LL: '#38bdf8', Mr: '#78350f',
  Cristal: '#e0f2fe', 'Nú': '#b87333', 'Vd/Am': '#84cc16', 'pt/vm': '#7f1d1d',
  Un: '#cbd5e1',
};

/** Fundos escuros pedem texto claro no cabeçalho colorido. */
const FUNDO_ESCURO = ['Az', 'Pt', 'Vd', 'Vm', 'LJ', 'Mr', 'pt/vm'];

export function tintaSobre(cor: string): string {
  return FUNDO_ESCURO.includes(cor) ? '#ffffff' : '#0f172a';
}

export const NOME_COR: Record<string, string> = {
  Am: 'amarelo', Az: 'azul', Bc: 'branco', Pt: 'preto', Vd: 'verde', Vm: 'vermelho',
  Cz: 'cinza', LJ: 'laranja', LL: 'azul claro', Mr: 'marrom', Cristal: 'cristal',
  'Nú': 'nu', 'Vd/Am': 'verde/amarelo', 'pt/vm': 'preto/vermelho', Un: 'sem cor',
};

/**
 * Só as cores que aparecem nesta cotação, na ordem da planilha. Uma cotação de
 * cobre usa seis ou sete das catorze — abrir catorze colunas vazias só afasta
 * as que interessam.
 */
export function coresPresentes(linhas: { cores: Record<string, number> }[]): string[] {
  const usadas = new Set<string>();
  linhas.forEach((linha) => Object.keys(linha.cores).forEach((cor) => usadas.add(cor)));

  const conhecidas = ORDEM_CORES.filter((cor) => usadas.has(cor));
  const resto = [...usadas].filter((cor) => !ORDEM_CORES.includes(cor)).sort();

  return [...conhecidas, ...resto];
}

/** Lembra entre visitas como o comprador prefere ver a distribuição. */
export type Visao = 'colunas' | 'resumo';

const CHAVE = 'condusvale:visao-cores';

export function visaoSalva(): Visao {
  try {
    return localStorage.getItem(CHAVE) === 'resumo' ? 'resumo' : 'colunas';
  } catch {
    return 'colunas';
  }
}

export function salvarVisao(visao: Visao): void {
  try {
    localStorage.setItem(CHAVE, visao);
  } catch {
    // Navegador com armazenamento bloqueado: a escolha vale só para esta sessão.
  }
}
